;(function ($) {
  $(document).ready(() => {
    
  })
})(jQuery);
